import React, { useState, useEffect } from 'react';
import FalconComponentCard from 'components/common/FalconComponentCard';
import IconButton from 'components/common/IconButton';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import AdvanceTableFooter from 'components/common/advance-table/AdvanceTableFooter';
import AdvanceTableSearchBox from 'components/common/advance-table/AdvanceTableSearchBox';
import AdvanceTableWrapper from 'components/common/advance-table/AdvanceTableWrapper';
import { useFormatDate } from 'hooks';
import { toast } from 'react-toastify';
import firebase from './../../../firebase';
import { Col, OverlayTrigger, Tooltip, Form, Row } from 'react-bootstrap';
import logoAirbnb from 'assets/img/logos/airbnb_logo.png';
import logoexpedia from 'assets/img/logos/expedia.png';
import logoabritel from 'assets/img/logos/abritel.png';
import logodirect from 'assets/img/logoIcon.png';
import tripadvisor from 'assets/img/logos/tripadvisor.jpg';
import locasun from 'assets/img/logos/locasun.png';
import homeToGo from 'assets/img/logos/homeToGo.jpeg'
import kayak from 'assets/img/logos/kayak.webp'
import homerez from 'assets/img/logos/homerez.png'
import booking from 'assets/img/logos/booking.png'
import { makeCsv, getTableDataForExport, getColKeyArrayObject } from 'state/actions/users';

const Bookings = () => {

  const [selectedYear, setSelectedYear] = useState("Tous");
  const [years, setYears] = useState([]);
  const [l, setL] = React.useState(false);
  const [data, setData] = React.useState([]);
  const [colexport, setColExport] = React.useState([]);

  const logo = (l) => {
    switch (l?.value) {
      case "booking":
        return <OverlayTrigger
          placement="top"
          overlay={
            <Tooltip style={{ position: 'fixed' }}>
              {l.label}
            </Tooltip>
          }
        >
          <img
            src={booking}
            alt={l}
            width={50}
          />
        </OverlayTrigger>
      case "homerez":
        return <OverlayTrigger
          placement="top"
          overlay={
            <Tooltip style={{ position: 'fixed' }}>
              {l.label}
            </Tooltip>
          }
        >
          <img
            src={homerez}
            alt={l}
            width={50}
          />
        </OverlayTrigger>
      case "kayak":
        return <OverlayTrigger
          placement="top"
          overlay={
            <Tooltip style={{ position: 'fixed' }}>
              {l.label}
            </Tooltip>
          }
        >
          <img
            src={kayak}
            alt={l}
            width={50}
          />
        </OverlayTrigger>
      case "homeToGo":
        return <OverlayTrigger
          placement="top"
          overlay={
            <Tooltip style={{ position: 'fixed' }}>
              {l.label}
            </Tooltip>
          }
        >
          <img
            src={homeToGo}
            alt={l}
            width={50}
          />
        </OverlayTrigger>
      case "locasun":
        return <OverlayTrigger
          placement="top"
          overlay={
            <Tooltip style={{ position: 'fixed' }}>
              {l.label}
            </Tooltip>
          }
        >
          <img
            src={locasun}
            alt={l}
            width={50}
          />
        </OverlayTrigger>
      case "tripadvisor":
        return <OverlayTrigger
          placement="top"
          overlay={
            <Tooltip style={{ position: 'fixed' }}>
              {l.label}
            </Tooltip>
          }
        >
          <img
            src={tripadvisor}
            alt={l}
            width={50}
          />
        </OverlayTrigger>
      case "direct":
        return <OverlayTrigger
          placement="top"
          overlay={
            <Tooltip style={{ position: 'fixed' }}>
              {l.label}
            </Tooltip>
          }
        >
          <img
            src={logodirect}
            alt={l}
            width={50}
          />
        </OverlayTrigger>
      case "abritel":
        return <OverlayTrigger
          placement="top"
          overlay={
            <Tooltip style={{ position: 'fixed' }}>
              {l.label}
            </Tooltip>
          }
        >
          <img
            src={logoabritel}
            alt={l}
            width={50}
          />
        </OverlayTrigger>
      case "airbnb":
        return <OverlayTrigger
          placement="top"
          overlay={
            <Tooltip style={{ position: 'fixed' }}>
              {l.label}
            </Tooltip>
          }
        >
          <img
            src={logoAirbnb}
            alt={l}
            width={30}
          />
        </OverlayTrigger>
      case "expedia":
        return <OverlayTrigger
          placement="top"
          overlay={
            <Tooltip style={{ position: 'fixed' }}>
              {l.label}
            </Tooltip>
          }
        >
          <img
            src={logoexpedia}
            alt={l}
            width={30}
          />
        </OverlayTrigger>

      default:
        return <span>{l?.label}</span>;
    }
  }



  const loadBooking = () => {
    setL(true);
    firebase.firestore().collection('bookings').get().then((snap) => {
      let s = [];
      snap.forEach((d) => {
        var l = d.data();
        l.id = d.id;
        if (l?.delete) {
          // supprimer donc ne pas affiché
        } else {
          l.villa = l.property.label
          s.push(l)
        }

      })
      setData(s);
      // console.log('data', s[0])
      setColExport(getColKeyArrayObject(s));
      setL(false);
    }).catch((error) => {
      setL(false);
      var errorMessage = error.message;
      toast.error(errorMessage);
    })
  }


  useEffect(() => {
    // Fonction pour extraire les années des dates
    const extractYears = (dates) => {
      const allYears = dates.map(date => {
        if (date) {
          const year = new Date(date).getFullYear();
          return year;
        }
        return null;
      }).filter(year => year !== null);

      // Éviter les années en double et trier par ordre décroissant
      return [...new Set(allYears)].sort((a, b) => b - a);
    };

    // Récupérer toutes les dates de l'objet `data` que tu veux filtrer
    const dates = extractYears(data.map(item => item.checkin?.toDate()));
 // Ajouter "Tous" au début de la liste
 const datesWithAllOption = ["Tous", ...dates];

 setYears(datesWithAllOption);
  }, [data]);

  const handleYearChange = (e) => {
    setSelectedYear(e.target.value);
  };

  const delIt = async (id) => {
    setL(true);
    try {
      firebase.firestore().collection('bookings').doc(id).update({ delete: true }).then((snap) => {

        toast.success("Suppression effectué");
        loadBooking();
      })
    } catch (err) {
      setL(false);
      // eslint-disable-next-line no-console
      console.log(err);
      toast.error("Une erreur s'est produite");
    }
  };
  const del = (id) => {
    if (confirm(`Êtes vous certain de vouloir supprimer la réservation?`)) {
      delIt(id);
    }
  }


  const columns = [
    {
      accessor: 'origin',
      Header: 'Origine',
      headerProps: { className: 'text-900' },
      Cell: ({ row }) => (
        <div style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }}>
          {logo(row.original?.origin)}
        </div>
      )
    },
    {
      accessor: 'number_booking',
      Header: 'N°',
      headerProps: { className: 'text-900' },
      Cell: ({ row }) => (
        <p style={{ textAlign: 'center' }}>{row.original?.number_booking ? row.original?.number_booking : row.original?.origin_id}</p>

      )
    },
    {
      accessor: 'guest',
      Header: 'Guest',
      headerProps: { className: 'text-900' },
      Cell: rowData => {
        const { guest, adultNbr, kidsNbr } = rowData.row.original;
        return (
          <>
            <p style={{ textAlign: 'center' }}>{guest.lastName} {guest.firstName}<br />
              {adultNbr} adulte{adultNbr > 1 ? 's' : ''}
              {kidsNbr > 0 && (<><br />{kidsNbr} enfant{kidsNbr > 1 ? 's' : ''}</>)}
            </p>
          </>
        )
      }
    },
    {
      accessor: 'emails',
      Header: 'Email',
      headerProps: { className: 'text-900' },
      Cell: rowData => {
        const { emails } = rowData.row.original;
        if (emails?.length > 0) {
          return (
            emails?.map((email) => {
              return (
                <p><a class="badge badge rounded-pill badge-subtle-warning" href={`mailto:${email}`}>{email}</a></p>
              )
            })
          )
        } else {
          return (
            <p>Aucun email</p>
          )
        }

      }
    },
    {
      accessor: 'statut',
      Header: 'Statut',
      headerProps: { className: 'text-900' },
      Cell: rowData => {
        return <p><a class="badge badge rounded-pill badge-subtle-success">{rowData?.row?.original?.statut?.label === "Confirmer" ? "Confirmé" : rowData?.row?.original?.statut?.label}</a></p>
      }
    },
    {
      accessor: 'villa',
      Header: 'Villa',
      headerProps: { className: 'text-900' },
    },

    {
      accessor: 'checkin',
      Header: 'Check-in',
      headerProps: { className: 'text-900' },
      Cell: ({ row }) => (
        <>{row?.original?.checkin && row?.original?.checkin?.toDate !== undefined && (
          <small className="has-text-grey is-abbr-like">
            {useFormatDate(row.original?.checkin?.toDate(), {
              day: 'numeric',
              weekday: 'short',
              year: 'numeric',
              month: 'short',
            })}
          </small>
        )}
        </>
      ),
    },

    {
      accessor: 'checkout',
      Header: 'Check-out',
      headerProps: { className: 'text-900' },
      Cell: ({ row }) => (
        <>{row?.original?.checkout && row?.original?.checkout?.toDate !== undefined && (
          <small className="has-text-grey is-abbr-like">
            {useFormatDate(row.original?.checkout?.toDate(), {
              day: 'numeric',
              weekday: 'short',
              year: 'numeric',
              month: 'short',
            })}
          </small>
        )}
        </>
      ),
    },

    // {
    //   accessor: 'booked_date',
    //   Header: 'Réserver le',
    //   headerProps: { className: 'text-900' }, 
    //   Cell: ({ row }) => (
    //     <>{row?.original?.booked_date && row?.original?.booked_date?.toDate !== undefined && (
    //        <small className="has-text-grey is-abbr-like">
    //           {useFormatDate(row.original?.booked_date?.toDate(), {
    //             day:'numeric',
    //             weekday: 'short',
    //             year: 'numeric',
    //             month: 'short', 
    //           })}
    //         </small> 
    //     )}
    //     </>
    //   ),
    // }, 

    {
      accessor: 'total_pay',
      Header: 'Total',
      headerProps: { className: 'text-900' },
      Cell: rowData => {
        const { total_pay } = rowData.row.original
        return <span>{total_pay} €</span>
      }
    },
    {
      accessor: 'action',
      Header: 'Action',
      headerProps: { className: 'text-900' },
      Cell: rowData => {
        const { email, id } = rowData.row.original
        return (<>

          <IconButton href={`/booking/edit/${id}`}
            variant="falcon-default"
            size="sm"
            icon="edit"
            transform="shrink-3"
            className='me-2'
          >
            <span className="d-none d-sm-inline-block ms-1"></span>
          </IconButton>


          <IconButton onClick={() => {
            del(id);
          }}
            variant="falcon-danger"
            size="sm"
            icon="trash"
            transform="shrink-3"
            className='me-2'
          >
            <span className="d-none d-sm-inline-block ms-1"></span>
          </IconButton>
        </>
        )
      }
    }
  ];

  React.useEffect(() => {
    if (data.length === 0) {
      loadBooking()
    }
  }, []);

  // const data = [
  //   {
  //     id: '345678',
  //     firstName: 'Anna',
  //     lastName: 'Anna',
  //     email: 'anna@example.com',
  //     phone: "06933322525", 
  //     type:"modérateur"
  //   },
  //   {
  //     id: '345678',
  //     firstName: 'Anna',
  //     lastName: 'Anna',
  //     email: 'anna@example.com',
  //     phone: "06933322525", 
  //     type:"admin"
  //   },
  // ];


   
  const filterannee = data
  .filter((d) => {
    // Si "Tous" est sélectionné, ne pas filtrer par année
    if (selectedYear === "Tous") return true;

    // Sinon, filtrer par l'année sélectionnée
    return d.checkin?.toDate().getFullYear() === Number(selectedYear);
  })
  .sort((a, b) => {
    const checkinA = a.checkin?.toDate();
    const checkinB = b.checkin?.toDate();

    // Trier par `checkin`, si `checkin` est nul, le mettre à la fin
    if (checkinA && checkinB) {
      return checkinA - checkinB; // Tri croissant
    }
    return checkinA ? -1 : 1; // Si l'un des checkin est nul, il va à la fin
  });
  function AdvanceTableExample() {

    if (l) {
      return <p>Chargement...</p>
    }
    return (
      <AdvanceTableWrapper
        columns={columns}
        data={filterannee}
        sortable
        pagination
        perPage={205}
      >


        <Col xs={8} sm="auto" className="ms-auto text-end ps-0 mb-3 mr-2">
          <div id="orders-actions">
            <IconButton href="/newbooking"
              variant="falcon-default"
              size="sm"
              icon="plus"
              transform="shrink-3"
              className='me-2'
            >
              <span className="d-none d-sm-inline-block ms-1">Nouvelle réservation</span>
            </IconButton>



            {data && data.length > 0 && (
              <IconButton

                variant="falcon-default"
                size="sm"
                icon="file"
                transform="shrink-3"
                className='me-2'
                onClick={() => makeCsv(getTableDataForExport(data, colexport), `booking-bo-house.csv`)}

              >
                Export des données en CSV
              </IconButton>)}

            <Row >
              <Col xs="auto" sm={6} lg={4}>
                <AdvanceTableSearchBox table />
              </Col>
              <Col xs="auto" sm={2} lg={2}>
                <Form.Group className="mb-3">
                  <Form.Control as="select" value={selectedYear} onChange={handleYearChange}>
                    {years.map((year) => (
                      <option key={year} value={year}>
                        {year}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group></Col>
            </Row>
          </div>
        </Col>
        <AdvanceTable
          table
          headerClassName="bg-200 text-nowrap align-middle"
          rowClassName="align-middle white-space-nowrap"
          tableProps={{
            bordered: true,
            striped: true,
            className: 'fs--1 mb-0 overflow-hidden'
          }}
        />
        <div className="mt-3">
          <AdvanceTableFooter
            rowCount={filterannee.length}
            table
            rowInfo
            navButtons
            rowsPerPageSelection
          />
        </div>
      </AdvanceTableWrapper>
    );
  }


  return (

    <FalconComponentCard>
      <FalconComponentCard.Header
        title="Réservations"
        light={false}
        className="border-bottom border-200" noPreview={true}
      />
      <FalconComponentCard.Body>
        <AdvanceTableExample />
      </FalconComponentCard.Body>
    </FalconComponentCard>
  );
}

export default Bookings;
